module.exports = __webpack_public_path__ + "media/images/logo-white-79cefeed03ae46616523beb93a0bb872.png";